
import { styled } from '@mui/system';
import { createTheme } from '@mui/material/styles';

export const PerlmanGreen = '#059669';
export const FontLite = '#f8f6f0';
export const MobileBreakPoint = 600;

export const buttonStyles = {
    bgcolor: PerlmanGreen,
    boxSizing: 'border-box',
    borderRadius: '10px',
    boxShadow: 'none',
    fontSize: '1.14rem',
    fontWeight: '700',
    fontFamily: 'brandon-regular,sans-serif',
    textTransform: 'none',
    margin: 'none',
    padding: '8px 15px;',
    '&:hover': {
        backgroundColor: PerlmanGreen,
        color: '#000',
        boxShadow: '0px 0px 4px 4px #eee',
    },
};

export const notSureStyles = {
    color: PerlmanGreen,
    textTransform: 'none',
    fontSize: '1.14rem',
    '&:hover': {
        backgroundColor: 'initial',
    },
};

export const NotSureButtonContainer = styled('div')(({ theme }) => ({
    display: 'inline=flex',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

export const defaultButtonStyles = {
    bgcolor: 'none',
    boxSizing: 'border-box',
    border: '.5px solid #CCC',
    backgroundColor: '#FFF',
    borderRadius: '0px',
    color: '#000',
    boxShadow: 'none',
    fontSize: '1.14rem',
    fontWeight: '700',
    fontFamily: 'brandon-regular,sans-serif',
    textTransform: 'none',
    margin: 'none',
    padding: '8px 15px;',
    '&:hover': {
        backgroundColor: '#CCC',
        border: '.5px solid #CCC',
    },
};

export const searchStyles = {};

export const LinkStyles = {
    color: PerlmanGreen,
    cursor: 'pointer',
    textDecoration: 'none',
};

export const LinkText = {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '1vm',
};

export const SearchContainer = styled('div')({
    position: 'relative',
    margin: '12px auto',
    display: 'block',
});

export const ButtonArrayContainer = styled('div')({
    border: '0.5px solid grey',
    borderRadius: '8px',
    display: 'block',
    padding: '20px',
    backgroundColor: '#fff',
    letterSpacing: '.1px',
});

export const ButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    '& > button': {
        margin: '10px',
    },
    [theme.breakpoints.down('lg')]: {
        display: 'block',
        '& > button': {
            margin: '2.5%',
            display: 'inline-block',
            width: '45%',
        },
    },
}));

export const InlineButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > button': {
        margin: '10px',
    },
    [theme.breakpoints.down('xs')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
        gap: '12px',
    },
}));

export const StackedButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > button': {
        margin: '10px',
    },
    [theme.breakpoints.down('sm')]: {
        display: 'block',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
        gap: '12px',
        '& > button': {
            width: '95%',
        },
    },
}));

export const SectionHeader = styled('h2')({
    margin: '1em 0',
    fontSize: '1.2rem',
    color: '#444',
    textAlign: 'left',
    letterSpacing: '.1px',
    fontFamily: 'brandon-regular,sans-serif',
});

export const H2 = styled('h2')({
    color: '#000',
});

export const Paragraph = styled('p')({
    fontSize: '1.2rem',
    fontFamily: 'brandon-regular,sans-serif',
    marginTop: '5px',
    color: '#000',
});
export const Strong = styled('strong')({
    fontSize: '1.2rem',
    fontFamily: 'brandon-bold,sans-serif',
    color: '#000',
    lineHeight: '2.2rem',
});

export const NoMatchContainer = styled('div')({
    border: '0.5px solid grey',
    borderRadius: '8px',
    display: 'block',
    backgroundColor: '#fff',
    letterSpacing: '.1px',
    margin: '15px 0px',
    padding: '15px',
    overflow: 'hidden',
});

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    typography: {
        fontFamily: [ '"brandon-regular"', 'Sans-serif' ].join(','),
        h1: {
            fontSize: '2.7rem',
            fontFamily: [ '"brandon-grotesque-medium"', 'Sans-serif' ].join(','),
            marginBottom: '10px',
        },
    },
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    display: 'block',
                    fontFamily: 'brandon-regular,sans-serif',
                    borderRadius: '40px',
                    border: '1px solid #ccc',
                    margin: 'auto',
                    width: '100%',
                    background: '#FFF',
                    fieldset: {
                        border: 'none',
                    },
                    '&:focus': {
                        borderRadius: '0px',
                    },
                    '& input': {
                        padding: '13px',
                        '&::placeholder': {
                            color: '#000',
                        },
                    },
                    '@media (max-width:900px)': {
                        '&': {
                            borderRadius: '20px 20px 0px 0px',
                        },
                        '& input': {
                            padding: '0px !important',
                            fontSize: '1rem',
                        },
                    },
                },
                listbox: {
                    boxShadow: '0 0 12px 3px #ccc',
                    '@media (max-width:900px)': {
                        '&': {
                            fontSize: '1rem',
                        },
                    },
                },
                popper: {
                    root: {
                        boxShadow: '0 0 12px 3px #ccc',
                    },
                },
                option: {},
            },
        },
        MuiDialog: {
            styleOverrides: {
                container: {
                    '&>.MuiPaper-root': {
                        position: 'absolute',
                        top: '0%',
                    },
                },
            },
        },
    },
});
theme.typography.h1[theme.breakpoints.down('sm')] = {
    fontSize: '1.5rem',
};

export default theme;
